import React, { PropsWithChildren } from 'react';
import styles from './LoadingGlobal.module.css';

export interface LoadingGlobalProps {
  message?: string;
}

export default function LoadingGlobal({ children, message }: PropsWithChildren<LoadingGlobalProps>) {
  return (
    <div className={styles.container}>
      <div className={`${styles.loading}`}>
        <div className={`loading medium`}></div>
        {message && <p>{message}</p>}
        {children}
      </div>
    </div>
  );
}
